import { Button } from "@msuite/ui/button";
import { useDisclosure } from "@msuite/ui/hooks";
import { Icon } from "@msuite/ui/icons";
import { useTranslation } from "@msuite/ui/localization";
import React from "react";
import { AddCalculationMemberModal } from "@/modals/calculations/add-calculation-member-modal";

/** Props Interface */
interface CalculationFormMembersMenuProps {
	calculationId: string;
	excludeUserIds: string[];
	refetch: () => Promise<void> | void;
}

export function CalculationFormMembersMenu({
	calculationId,
	excludeUserIds,
	refetch,
}: CalculationFormMembersMenuProps) {
	/** Hooks */
	const { t } = useTranslation();
	const addMemberModal = useDisclosure();

	/** Render */
	return (
		<React.Fragment>
			<Button
				variant="primary"
				icon={<Icon name="Plus" />}
				onClick={addMemberModal.onOpen}
				data-cy="add-calculation-member-button"
			>
				{t("calculations.add_member")}
			</Button>
			{addMemberModal.isOpen && (
				<AddCalculationMemberModal
					isOpen={addMemberModal.isOpen}
					onClose={addMemberModal.onClose}
					calculationId={calculationId}
					excludeUserIds={excludeUserIds}
					onComplete={refetch}
				/>
			)}
		</React.Fragment>
	);
}
